import React from 'react';
import { Shield, Plus, Loader2, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RoleBulkActions = ({ 
  selectedRoles, 
  bulkActionLoading, 
  onBulkDelete,
  onOpenModal 
}) => {
  const navigate = useNavigate();

  const handleCreateRole = () => {
    navigate('/roles/create');
  };

  return (
    <div className="flex justify-between items-center">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">Gestion des Rôles</h2>
        {selectedRoles.length > 0 && (
          <p className="text-sm text-gray-500 mt-1">
            {selectedRoles.length} rôle(s) sélectionné(s)
          </p>
        )}
      </div>
      
      <div className="flex items-center space-x-3">
        {/* Actions en lot */}
        {selectedRoles.length > 0 && (
          <div className="flex items-center space-x-2 mr-4">
            <button
              onClick={onBulkDelete}
              disabled={bulkActionLoading}
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
            >
              {bulkActionLoading ? (
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              ) : (
                <Users className="h-4 w-4 mr-1" />
              )}
              Supprimer
            </button>
          </div>
        )}
        
        {/* Bouton d'ajout */}
        <button
          onClick={handleCreateRole}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#202654] hover:bg-[#1a1f45] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654]"
        >
          <Plus className="h-5 w-5 mr-2" />
          Nouveau Rôle
        </button>
      </div>
    </div>
  );
};

export default RoleBulkActions; 